<template>
  <div>
    <div v-if="showModals">
      <page-spinner :spinner-url-list="spinnerUrlList" />
      <cpr-consent-main-modal />
      <cpr-consent-accept-modal />
      <cpr-consent-decline-modal />
      <cpr-consent-error-modal />
    </div>
    <slot v-if="isCprConsentModalNotShown" />
  </div>
</template>

<script>
import CprConsentMainModal from './CprConsentMainModal.vue';
import CprConsentAcceptModal from './CprConsentAcceptModal.vue';
import CprConsentDeclineModal from './CprConsentDeclineModal.vue';
import CprConsentErrorModal from './CprConsentErrorModal.vue';
import PageSpinner from '@/components/UI/PageSpinner.vue';
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'CprConsent',
  components: {
    CprConsentMainModal,
    CprConsentAcceptModal,
    CprConsentDeclineModal,
    CprConsentErrorModal,
    PageSpinner
  },
  props: {
    datasource: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      isPageFullyLoaded: false
    };
  },
  computed: {
    showModals() {
      return this.$store.getters['cprConsent/showModals'];
    },
    spinnerUrlList() {
      return [Utility.constants().API.cpr_consent_submit];
    },
    isCprConsentModalNotShown() {
      const isCprConsentModalOnPage = this.$store.state.cprConsent.isOnPage;

      return this.isPageFullyLoaded && !(isCprConsentModalOnPage && this.showModals);
    }
  },
  created() {
    this.$store.dispatch('cprConsent/setIsOnPage', true);
    this.$store.dispatch('cprConsent/setInitialModel', this.datasource);

    Utility.windowReady(() => {
      this.isPageFullyLoaded = true;
    });
  }
};
</script>
